import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TranslationContext } from '../../../config/Translations';

class ProductConfiguration extends Component{
    constructor(props) {
        super(props);

        this.state = {
            configurationId: null,
            configurationOptionClass: "input__control input__select--unselected"
        }
    }

    getDefaultOption = translationContext => {
        const configNo = this.props.configKey + 1;
        return this.props.productQuantity > 1 || this.props.bundleQuantity > 1
            ? translationContext.t('checkout__select_number_option', {
                configNo,
                option: this.props.product.configurations[0].optionName
            })
            : translationContext.t('checkout__select_option', {
                option: this.props.product.configurations[0].optionName
            });
    };

    render() {
        return(
            <TranslationContext.Consumer>
            {t =>
                <div className="input__select" key={'pc_select_' + this.props.configKey}>
                    <select className={this.state.configurationOptionClass} name="product_config"
                            ref={(input) => {this.state.configurationId = input}}
                            onChange={this.onProductConfigChange}
                    >
                        {<option value="" key={'pc_opt_' + this.props.configKey}>{this.getDefaultOption(t)}</option>}
                        {this.props.product.configurations.map((configuration, i) => {
                            if (configuration.display_name !== "") {
                                return (
                                    <option value={configuration.product_configuration_id} key={'option_' + i}>
                                        {configuration.display_name}
                                    </option>)
                            }
                        })}
                    </select>
                </div>
            }
            </TranslationContext.Consumer>

        )
    }

    onProductConfigChange = () => {
        if (this.state.configurationId.value !== null && this.state.configurationId.value !== "") {
            this.setState({configurationOptionClass: "input__control"});
        } else {
            this.setState({configurationOptionClass: "input__control input__select--unselected"});
        }

        this.props.onProductConfigChange({
            index: this.props.configKey,
            productId: this.props.product.product_id,
            configurationId: this.state.configurationId.value,
        });
    }
}

ProductConfiguration.propTypes = {
    product: PropTypes.object.isRequired,
    bundle: PropTypes.object,
    configKey: PropTypes.number,
    onProductConfigChange: PropTypes.func.isRequired,
    productQuantity: PropTypes.number,
    bundleQuantity: PropTypes.number,
};

export default ProductConfiguration;
